// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import SharedHeader from "../../components/SharedHeader";
// import SharedFooter from "../../components/SharedFooter";
// import OTPDialog from "../../components/OtpDialog";
// import { useAuth } from "../../components/AuthContext";
// import { api } from "../../services/api";
// import { tokenStorage } from "../../utils/tokenStorage";

// export default function Login() {
//   const navigate = useNavigate();
//   const { login, logout, userId } = useAuth();
//   const [userEmail, setUserEmail] = useState("");
//   const [userPassword, setUserPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showOTP, setShowOTP] = useState(false);

//   // Clean up stale data
//   useEffect(() => {
//     if (!tokenStorage.isLoggedIn() && localStorage.getItem("user")) {
//       tokenStorage.clear();
//       logout();
//     }
//   }, []);

//   // Redirect if already logged in
//   useEffect(() => {
//     if (userId && tokenStorage.isLoggedIn()) {
//       const userData = tokenStorage.getUser() || {};
//       const role = userData.userRole;
//       if (role === "Admin") {
//         navigate("/admin-dashboard");
//       } else {
//         navigate("/user-dashboard");
//       }
//     }
//   }, [userId, navigate]);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");
//     try {
//       const res = await api.post("/users/login", {
//         userEmail,
//         userPassword,
//       });

//       const { message: msg, data } = res.data;

//       // Email-not-verified path: backend returns user directly (no tokens yet).
//       // Wait for OTP verification.
//       if (!data?.user?.isUserEmailVerified && !data?.isUserEmailVerified) {
//         setShowOTP(true);
//         return;
//       }

//       // Verified path: backend returns LoginPayload { accessToken, refreshToken, user }
//       const user = data.user;
//       const accessToken = data.accessToken;
//       const refreshToken = data.refreshToken;

//       if (accessToken && refreshToken) {
//         tokenStorage.saveTokens(accessToken, refreshToken);
//       }
//       if (user) {
//         tokenStorage.saveUser(user);
//       }

//       login(user?.userId, user?.userEmail, user?.userName || "User");
//       localStorage.setItem("sessionStart", Date.now().toString());
//       setMessage(msg || "Login successful");

//       if (user?.userRole === "Admin") {
//         navigate("/admin-dashboard", { replace: true });
//       } else {
//         navigate("/user-dashboard", { replace: true });
//       }
//     } catch (err) {
//       setMessage(err.response?.data?.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (userId && tokenStorage.isLoggedIn()) return null;

//   return (
//     <>
//       <SharedHeader />

//       <div className="max-w-md mx-auto p-6 bg-white mt-8 shadow rounded">
//         <h2 className="text-2xl font-semibold mb-4">Login</h2>
//         <form onSubmit={handleLogin} className="space-y-4">
//           <input
//             className="w-full border p-2 rounded"
//             type="email"
//             value={userEmail}
//             onChange={(e) => setUserEmail(e.target.value)}
//             placeholder="Email"
//             required
//           />

//           <div className="relative">
//             <input
//               className="w-full border p-2 pr-10 rounded"
//               type={showPassword ? "text" : "password"}
//               value={userPassword}
//               onChange={(e) => setUserPassword(e.target.value)}
//               placeholder="Password"
//               required
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword((prev) => !prev)}
//               className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
//               aria-label={showPassword ? "Hide password" : "Show password"}
//               tabIndex={-1}
//             >
//               {showPassword ? <EyeOffIcon /> : <EyeIcon />}
//             </button>
//           </div>

//           <button
//             className={`bg-blue-600 text-white py-2 px-4 rounded w-full ${
//               loading ? "opacity-60 cursor-not-allowed" : ""
//             }`}
//             type="submit"
//             disabled={loading}
//           >
//             {loading ? "Logging in..." : "Login"}
//           </button>
//         </form>

//         {message && (
//           <div className="mt-4 p-2 bg-gray-100 text-center text-sm text-gray-700 border rounded">
//             {message}
//           </div>
//         )}
//       </div>

//       <OTPDialog
//         open={showOTP}
//         onClose={() => setShowOTP(false)}
//         onVerified={(verifiedPayload) => {
//           setMessage("Email verified and logged in");
//           setShowOTP(false);

//           // After OTP, backend returns LoginPayload too
//           const user = verifiedPayload?.user;
//           const accessToken = verifiedPayload?.accessToken;
//           const refreshToken = verifiedPayload?.refreshToken;

//           if (accessToken && refreshToken) {
//             tokenStorage.saveTokens(accessToken, refreshToken);
//           }
//           if (user) {
//             tokenStorage.saveUser(user);
//           }

//           login(
//             user?.userId || userEmail,
//             user?.userEmail || userEmail,
//             user?.userName || "User"
//           );
//           localStorage.setItem("sessionStart", Date.now().toString());

//           if (user?.userRole === "Admin") {
//             navigate("/admin-dashboard", { replace: true });
//           } else {
//             navigate("/user-dashboard", { replace: true });
//           }
//         }}
//         email={userEmail}
//       />

//       <SharedFooter />
//     </>
//   );
// }

// function EyeIcon() {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       className="h-5 w-5"
//       fill="none"
//       viewBox="0 0 24 24"
//       stroke="currentColor"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//       />
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//       />
//     </svg>
//   );
// }

// function EyeOffIcon() {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       className="h-5 w-5"
//       fill="none"
//       viewBox="0 0 24 24"
//       stroke="currentColor"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
//       />
//     </svg>
//   );
// }
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import SharedHeader from "../../components/SharedHeader";
import SharedFooter from "../../components/SharedFooter";
import OTPDialog from "../../components/OtpDialog";
import { useAuth } from "../../components/AuthContext";
import { api } from "../../services/api";
import { tokenStorage } from "../../utils/tokenStorage";

export default function Login() {
  const navigate = useNavigate();
  const { login, logout, userId, userRole } = useAuth();    // ← add userRole
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  // Clean up stale data
  useEffect(() => {
    if (!tokenStorage.isLoggedIn() && localStorage.getItem("user")) {
      tokenStorage.clear();
      logout();
    }
  }, []);

  // Redirect if already logged in
  useEffect(() => {
    if (userId && tokenStorage.isLoggedIn()) {
      if (userRole === "ADMIN") {
        navigate("/admin-dashboard", { replace: true });
      } else if (userRole) {                              // ← only redirect if role is known
        navigate("/user-dashboard", { replace: true });
      }
    }
  }, [userId, userRole, navigate]);                       // ← add userRole to deps

  const navigateByRole = (user) => {
  if (user?.userRole === "ADMIN") {
    navigate("/admin-dashboard", { replace: true });
  } else {
    navigate("/user-dashboard", { replace: true });
  }
};

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const res = await api.post("/users/login", {
        userEmail,
        userPassword,
      });

      const { message: msg, data } = res.data;

      if (!data?.user?.isUserEmailVerified && !data?.isUserEmailVerified) {
        setShowOTP(true);
        return;
      }

      const user = data.user;
      const accessToken = data.accessToken;
      const refreshToken = data.refreshToken;

      if (accessToken && refreshToken) {
        tokenStorage.saveTokens(accessToken, refreshToken);
      }
      if (user) {
        tokenStorage.saveUser(user);
      }

      login(user?.userId, user?.userEmail, user?.userName || "User", user?.userRole);  // ← add userRole
      localStorage.setItem("sessionStart", Date.now().toString());
      setMessage(msg || "Login successful");

      navigateByRole(user);

    } catch (err) {
      setMessage(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  if (userId && tokenStorage.isLoggedIn()) return null;

  return (
    <>
      <SharedHeader />

      <div className="max-w-md mx-auto p-6 bg-white mt-8 shadow rounded">
        <h2 className="text-2xl font-semibold mb-4">Login</h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            className="w-full border p-2 rounded"
            type="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            placeholder="Email"
            required
          />

          <div className="relative">
            <input
              className="w-full border p-2 pr-10 rounded"
              type={showPassword ? "text" : "password"}
              value={userPassword}
              onChange={(e) => setUserPassword(e.target.value)}
              placeholder="Password"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </button>
          </div>

          <button
            className={`bg-blue-600 text-white py-2 px-4 rounded w-full ${
              loading ? "opacity-60 cursor-not-allowed" : ""
            }`}
            type="submit"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {message && (
          <div className="mt-4 p-2 bg-gray-100 text-center text-sm text-gray-700 border rounded">
            {message}
          </div>
        )}
      </div>

      <OTPDialog
        open={showOTP}
        onClose={() => setShowOTP(false)}
        onVerified={(verifiedPayload) => {
          setMessage("Email verified and logged in");
          setShowOTP(false);

          const user = verifiedPayload?.user;
          const accessToken = verifiedPayload?.accessToken;
          const refreshToken = verifiedPayload?.refreshToken;

          if (accessToken && refreshToken) {
            tokenStorage.saveTokens(accessToken, refreshToken);
          }
          if (user) {
            tokenStorage.saveUser(user);
          }

          login(
            user?.userId || userEmail,
            user?.userEmail || userEmail,
            user?.userName || "User",
            user?.userRole                    // ← add userRole
          );
          localStorage.setItem("sessionStart", Date.now().toString());

          navigateByRole(user);
        }}
        email={userEmail}
      />

      <SharedFooter />
    </>
  );
}

function EyeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0.01-4.132 5.411m0 0L21 21"
      />
    </svg>
  );
}